export enum SystemUserMode {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
}
